import { useCallback, useRef } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

import { Mean } from './Mean'

export const SubscapularInput: React.FC = () => {
  const subscapularRef = useRef(evaluationAtom.get()?.subscapular ?? [])

  const handleUpdateField = useCallback(
    (index: number, value: number) => {
      const newArr = [...subscapularRef.current]
      newArr[index] = value
      subscapularRef.current = newArr
      patchEvaluationAtom({ subscapular: newArr })
    },
    [],
  )

  const handleFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(4)
  }, [])

  return (
    <>
      <div className='font-bold xl:font-normal'>Subescapular (mm) &nbsp;</div>
      {subscapularRef.current.map((val, index) => (
        <div key={`subscapular-${index}`}>
          <p className='block xl:hidden mb-2'>Medida {index + 1}</p>
          <MaskedInput
            value={val}
            placeholder='0'
            mask='integer'
            inputMode='numeric'
            onFocus={handleFocus}
            onChange={(v) => handleUpdateField(index, v)}
          />
        </div>
      ))}
      <div>
        <p className='block xl:hidden mb-2'>Média</p>
        <Mean field='subscapular' />
      </div>
    </>
  )
}
